import { type ErrorComponentProps, useRouter } from '@tanstack/react-router'
import { CloudOffIcon } from 'lucide-react'

import { Button } from '@damis/ui/components/button'

/**
 * What a screen shows when its loader or component throws: the API mid-deploy, a lost
 * connection, a build the page has outlived. "Try again" runs the loaders again in place, which
 * is what a passing outage needs; "Reload" starts the app over, which is what a stale build needs.
 */
export function RouteError({ reset }: ErrorComponentProps) {
  const router = useRouter()
  return (
    <main className="flex min-h-[60dvh] flex-col items-center justify-center bg-background px-6 py-16 text-center text-foreground">
      <CloudOffIcon className="size-8 text-muted-foreground" aria-hidden />
      <h1 className="mt-4 text-xl font-semibold tracking-tight">Something went wrong</h1>
      <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">
        This screen could not load. Check your connection and try again.
      </p>
      <div className="mt-4 flex gap-2">
        <Button
          onClick={() => {
            reset()
            void router.invalidate()
          }}
        >
          Try again
        </Button>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Reload the app
        </Button>
      </div>
    </main>
  )
}
